<header class="d-flex justify-content-end align-items-center">
  <app-dropdown-select-institution *ngIf="showSelect"></app-dropdown-select-institution>
  <app-logged-user-detail *ngIf="auth.user != undefined" [input]="auth.user"> </app-logged-user-detail>
</header>
